module.exports = __webpack_public_path__ + "static/img/fws_img_app.17c3f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/fws_img_app.png
// module id = xHJG
// module chunks = 1